import React, { Fragment } from 'react';
import { Plus, Trash2 } from 'react-feather';
import { SURVEY_ANSWERS_TYPE, SURVEY_ANSWERS_TYPE_HAS_CONDITIONAL, SURVEY_ANSWERS_TYPE_TEXT, SURVEY_QUESTION_CONDITION_TYPE, SURVEY_QUESTION_CONDITION_TYPE_TEXT } from '../../../utils/enums';
import Switch from '../../../components/common/switch/switch';
import AddButton from '../../../components/common/buttons/default';

const conditionalCardStyle = {
    borderLeft: '3px solid var(--main-secondary-color)',
    marginLeft: '20px',
    paddingLeft: '20px',
    marginTop: '15px'
};

const getSubQuestionParentConditionTypeOptions = (parentAnswerType) => {
    if (parentAnswerType == null) {
        return [];
    }

    if (parentAnswerType.toString() === SURVEY_ANSWERS_TYPE.OptionalDecimal.toString()) {
        return [
            { value: SURVEY_QUESTION_CONDITION_TYPE.Equals, label: SURVEY_QUESTION_CONDITION_TYPE_TEXT[SURVEY_QUESTION_CONDITION_TYPE.Equals] },
            { value: SURVEY_QUESTION_CONDITION_TYPE.GreaterThan, label: SURVEY_QUESTION_CONDITION_TYPE_TEXT[SURVEY_QUESTION_CONDITION_TYPE.GreaterThan] },
            { value: SURVEY_QUESTION_CONDITION_TYPE.LowerThan, label: SURVEY_QUESTION_CONDITION_TYPE_TEXT[SURVEY_QUESTION_CONDITION_TYPE.LowerThan] }
        ];
    }

    return [];
};

const Survey = ({ item, handleChange, removeItem, addConditionalSurvey, nestedLabel = null, parentAnswerType = null }) => {
    const hasConditionalSurvey = SURVEY_ANSWERS_TYPE_HAS_CONDITIONAL[item.answerType] === true;
    const hasMultipleChoiceOptions = item.answerType.toString() === SURVEY_ANSWERS_TYPE.CameraWithMultipleChoices.toString() || item.answerType.toString() === SURVEY_ANSWERS_TYPE.CameraWithMultipleChoicesPrice.toString();
    const isConditionalChild = parentAnswerType != null;
    const isBooleanParent = parentAnswerType != null && parentAnswerType.toString() === SURVEY_ANSWERS_TYPE.Bool.toString();
    const SubQuestionParentConditionTypeOptions = getSubQuestionParentConditionTypeOptions(parentAnswerType);

    return (
        <div style={nestedLabel ? conditionalCardStyle : {}}>
            {nestedLabel && <p className="main-color"><b>{nestedLabel}</b></p>}

            {isConditionalChild && (
                <div className="flex center" style={{ placeItems: "center" }}>
                    Se a resposta for:
                    {SubQuestionParentConditionTypeOptions.length > 0 &&
                        <div className="field-filter-item">
                            <select
                                style={{ width: '160px' }}
                                value={item.SubQuestionParentConditionType ?? SURVEY_QUESTION_CONDITION_TYPE.Equals}
                                onChange={handleChange}
                                id={"SubQuestionParentConditionType-" + item.id}
                                disabled={isBooleanParent}
                            >
                                {SubQuestionParentConditionTypeOptions.map((option) => (
                                    <option key={option.value} value={option.value}>{option.label}</option>
                                ))}
                            </select>
                        </div>
                    }

                    <div className="field-filter-item">
                        {isBooleanParent ? (
                            <select style={{ width: '160px' }} value={item.subQuestionParentConditionValue ?? 'true'} onChange={handleChange} id={"subQuestionParentConditionValue-" + item.id}>
                                <option value="true">Sim</option>
                                <option value="false">Não</option>
                            </select>
                        ) : (
                            <input className="form-control" type="number" placeholder="0" value={item.subQuestionParentConditionValue ?? ''} onChange={handleChange} id={"subQuestionParentConditionValue-" + item.id} />
                        )}
                    </div>
                </div>
            )}

            <div className="flex">
                <div className="field-filter-item">
                    <label className="label-filter">Pergunta</label>
                    <br />
                    <textarea className="form-control w-31vw" type="text" placeholder="Pergunta" value={item.title} onChange={handleChange} id={"title-" + item.id} />
                </div>

                <div className="field-filter-item">
                    <label className="label-filter">Formato resposta</label>
                    <br />
                    <select style={{ width: '218px' }} value={item.answerType} onChange={handleChange} id={"answerType-" + item.id}>
                        {Object.entries(SURVEY_ANSWERS_TYPE_TEXT).map(([key, value]) => (
                            <option key={key} value={key}>
                                {value}
                            </option>
                        ))}
                    </select>
                </div>

                {hasMultipleChoiceOptions && (
                    <Fragment>
                        <div className="field-filter-item">
                            <div style={{ maxWidth: '90px' }}>
                                <label className="label-filter">Resposta</label>
                                <label className="label-filter"> obrigatória</label>
                            </div>
                            <div style={{ marginTop: '-25px', paddingLeft: '15px' }}>
                                <Switch
                                    handleToggle={() => handleChange({ target: { id: `required-${item.id}`, value: !item.required } })}
                                    isOn={item.required === true}
                                    isOnColor="#203ada"
                                    isOffColor="#F9F9F9"
                                    value={item.required}
                                    id={"required-" + item.id}
                                />
                            </div>
                        </div>
                        <div className="field-filter-item">
                            <label className="label-filter">Opções de resposta</label>
                            <br />
                            <textarea className="form-control" type="text" placeholder="Produto|EAN;Produto2|EAN..." value={item.answerOptions} onChange={handleChange} id={"answerOptions-" + item.id} />
                        </div>
                    </Fragment>
                )}

                <div className="field-filter-item">
                    <label className="label-filter">Palavras-chave IA</label>
                    <br />
                    <input className="form-control" type="text" placeholder="item1;item2;item3..." value={item.AIFilterKeywords} onChange={handleChange} id={"AIFilterKeywords-" + item.id} />
                </div>

                <div className="field-filter-item remove-item" onClick={() => removeItem(item.id)}>
                    <Trash2 />
                </div>
            </div>

            {hasConditionalSurvey && (
                <Fragment>
                    {(item.conditionalQuestions || []).map((conditionalQuestion, index) => (
                        <Survey
                            key={conditionalQuestion.id}
                            item={conditionalQuestion}
                            handleChange={handleChange}
                            removeItem={removeItem}
                            addConditionalSurvey={addConditionalSurvey}
                            nestedLabel={`Sub-pergunta ${index + 1}`}
                            parentAnswerType={item.answerType}
                        />
                    ))}

                    <div className="flex ml-10 mt-10 mb-10">
                        <AddButton description="Adicionar sub-pergunta" icon={<Plus />} onClick={() => addConditionalSurvey(item.id)} small={true} />
                    </div>
                </Fragment>
            )}
        </div>
    );
}

export default Survey;